import { render, staticRenderFns } from "./StepInfo.vue?vue&type=template&id=19ce566b&scoped=true&"
import script from "./StepInfo.vue?vue&type=script&lang=ts&"
export * from "./StepInfo.vue?vue&type=script&lang=ts&"
import style0 from "./StepInfo.vue?vue&type=style&index=0&id=19ce566b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ce566b",
  null
  
)

export default component.exports